<!--  -->
<template>
  <div class="tabox">
    <div class="tabselecr_box">
      <div class="selectionArea">
        <div class="item">
          <span class="title">组名</span>
          <el-input
            v-model="query.group_number"
            clearable
            style="width:200px;"
            placeholder="请输入组名"
          />
        </div>
        <div class="item">
          <span class="title">是否主日志</span>
          <el-select
            v-model="query.record_type"
            clearable
            placeholder="请选择"
            :style="{ width: '200px' }"
          >
            <el-option
              v-for="item in states"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <el-button
            type="primary"
            style="margin:0px 10px"
            icon="el-icon-search"
            @click="searchclick"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh-right"
            @click="rechargeclick"
          >重置</el-button>
        </div>
      </div>
      <!-- <div>
        <el-button type="success" icon="el-icon-plus" @click="add">新增策略</el-button>
      </div> -->
    </div>
    <el-table
      v-loading="listLoading"
      :data="tabledata"
      max-height="750"
      border
    >
      <el-table-column
        prop="is_master_desc"
        width="200"
        label="日志"
        align="center"
      />
      <el-table-column
        prop="group_number"
        width="180"
        label="组号"
        align="center"
      />
      <el-table-column
        prop="status_desc"
        width="180"
        label="状态描述"
        align="center"
      />
      <el-table-column
        prop="account_id"
        width="80"
        label="账号"
        align="center"
      />
      <el-table-column
        prop="adgroup_ids"
        label="广告ID"
        align="center"
      >
        <template slot-scope="scope">
          <ExpandClose
            :my-values="scope.row.params.adgroup_ids.map((item)=>{
              return `${item}`
            })"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="account_ids"
        label="广告主ID"
        align="center"
      >
        <template slot-scope="scope">
          <ExpandClose
            :my-values="scope.row.params.account_ids.map((item)=>{
              return `${item}`
            })"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="fail_reason"
        label="失败原因"
        align="center"
      />
      <el-table-column
        prop="user_action_sets"
        label="用户行为数据源ID"
        align="center"
      >
        <template slot-scope="scope">
          <div
            v-for="item in scope.row.params.user_action_sets"
            :key="item"
          >
            {{ item }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="send_time_text"
        width="150"
        label="操作"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="lookinfo(scope.row)"
          >查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="详情"
      :visible.sync="dialogsendinfo"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="73%"
    >
      <sendinfo ref="sendinfoview" />
    </el-dialog>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>
<script>
import ExpandClose from '@/components/ExpandClose/index.vue'
import { select_adgroups_record } from '@/api/releaseGroup.js'
// import { tacticssend, spgetSentresult, remindCorpUserToSendMsg, thirdPartyPushRecords } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import sendinfo from './sendinfo.vue'
export default {
  components: { PaginationRight, sendinfo, ExpandClose },
  data() {
    return {
      query: {
        group_number: null,
        record_type: null,
        page: 1,
        pageSize: 10
      },
      dialogsendinfo: false,
      listLoading: false,
      tabledata: [],
      sendid: null,
      total: null,
      push_method: null,
      tabledatar: [],
      states: [
        { id: 1, value: '主日志' },
        { id: 2, value: '子日志' }
      ]
    }
  },
  created() {
    // this.query.sp_strategy_no = this.$route.query.id
    // this.push_method = this.$route.query.push_method
    // console.log('this.push_method', this.push_method)
    // eslint-disable-next-line eqeqeq
    this.list()
  },
  mounted() {},
  methods: {
    async list() {
      this.listLoading = true
      const data = await select_adgroups_record(this.query)
      this.tabledata = data.data.list
      this.total = data.data.count
      this.listLoading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      // eslint-disable-next-line eqeqeq
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      // eslint-disable-next-line eqeqeq
      this.list()
    },
    lookinfo(item) {
      console.log(item)
      this.dialogsendinfo = true
      this.$nextTick(() => {
        this.$refs.sendinfoview.send(item)
      })
    },
    searchclick() {
      this.query.page = 1
      // eslint-disable-next-line eqeqeq
      this.list()
    },
    rechargeclick() {
      this.query = {
        group_number: null,
        record_type: null,
        page: 1,
        pageSize: 10
      }
      this.list()
    },
    async remindsend(item) {
      // const data = await remindCorpUserToSendMsg({
      //   id: item.id
      // })
      // this.$message({
      //   message: '提醒员工发送成功',
      //   type: 'success'
      // })
      // this.list()
      // console.log('data', data)
    },
    updatar() {}
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tabox {
  padding: 30px;
}
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.titip {
  width: 180px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* 这里是超出几行省略 */
  overflow: hidden;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  flex-basis: calc(25% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
}
.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}
</style>
